import {useState} from 'react'
import {css} from '@emotion/react'
import {Button, ConfigProvider, Form} from 'antd'
import {DownOutlined, SearchOutlined, UpOutlined} from '@ant-design/icons'
import {normalizeChildren} from '@/script/react.mjs'

const ButtonReset = (props) => {
    return (
        <Button {...props}>
            重置
        </Button>
    )
}

const ButtonSubmit = (props) => {
    return (
        <Button
            icon={<SearchOutlined />}
            type="primary"
            {...props}
        >
            查询
        </Button>
    )
}

const ButtonToggleIsExpanded = ({isExpanded, ...props}) => {
    const [children, icon] = isExpanded ?
        ['收起', <UpOutlined />]
        :
        ['展开', <DownOutlined />]

    return (
        <Button
            icon={icon}
            type="link"
            {...props}
        >
            {children}
        </Button>
    )
}

const cssQueryForm = css({
    display: 'grid',
    gridTemplateColumns: 'repeat(var(--columns), 1fr)',
    alignItems: 'end',
    gap: 12,

    '.ant-form-item': {
        marginBottom: 0,
    },

    '&.ant-form-vertical .ant-form-item-label': {
        padding: 0,
    },

    '.ant-form-item-control-input': {
        minHeight: 'auto',
    },
})

const cssButtons = css({
    gridRow: 1,
    gridColumn: 'var(--columns)',
    display: 'flex',
    justifyContent: 'end',
    gap: 8,
})

const defaultGetQuery = a => a

export default function QueryForm({
    children,
    columns = 6,
    getQuery = defaultGetQuery,
    items,
    onFinish,
    ...props
}) {
    const [form] = Form.useForm()
    const [isExpanded, setIsExpaned] = useState(false)

    if (0 === items?.length) {
        return null
    }

    const [_children, childrenCount] = (() => {
        if (children) {
            const fullItems = normalizeChildren(children)

            return [
                isExpanded ?
                    fullItems
                    :
                    fullItems.slice(0, columns - 1),

                fullItems.length
            ]
        }
        else if (items) {
            const fullItems = items.filter(a => a)

            const displayedItems = isExpanded ?
                fullItems
                :
                fullItems.slice(0, columns - 1)

            return [
                displayedItems.map(
                    ({children, ...props}) => (
                        <Form.Item key={props.name} {...props}>
                            {children}
                        </Form.Item>
                    )
                ),

                fullItems.length
            ]
        }
        else {
            return [null, 0]
        }
    })()

    const onClickReset = () => {
        form.resetFields()
        const query = getQuery({...props.initialValues})
        onFinish?.(query)
    }

    const onClickSubmit = () => form.submit()
    const onClickToggle = () => setIsExpaned(b => ! b)

    const _onFinish = formValues => {
        const query = getQuery(formValues)
        onFinish?.(query)
    }

    const onKeyDown = e => {
        if ('Enter' === e.key) {
            form.submit()
        }
    }

    return (
        <Form
            css={cssQueryForm}
            style={{'--columns': columns}}
            form={form}
            onFinish={_onFinish}
            onKeyDown={onKeyDown}
            {...props}
        >
            <ConfigProvider componentSize="small">
                {_children}

                <div css={cssButtons}>
                    <ButtonReset onClick={onClickReset} />
                    <ButtonSubmit onClick={onClickSubmit} />

                    <ButtonToggleIsExpanded
                        hidden={childrenCount < columns}
                        isExpanded={isExpanded}
                        onClick={onClickToggle}
                    />
                </div>
            </ConfigProvider>
        </Form>
    )
}
